import { WIKI_ARTICLE_TYPE, WIKI_FAQ_LIST_TYPES } from './wiki-article-types';

export const WIKI_LISTING_PAGE_SIZE = 20;

export const WIKI_LISTING_SECTION = {
  all: 'all',
  faq: 'faq',
  harryPotterWiki: 'harry-potter-wiki',
} as const;

export type WikiListingSection = (typeof WIKI_LISTING_SECTION)[keyof typeof WIKI_LISTING_SECTION];

/** Combined wiki feed: current wiki sections only (FAQ + Harry Potter wiki). */
export const WIKI_ALL_LIST_TYPES = [
  ...WIKI_FAQ_LIST_TYPES,
  WIKI_ARTICLE_TYPE.harryPotterWiki,
] as const;

export const WIKI_LISTING_TABS = [
  { section: WIKI_LISTING_SECTION.all, label: 'ВСЕ', href: '/wiki' },
  { section: WIKI_LISTING_SECTION.faq, label: 'F.A.Q.', href: '/wiki/faq' },
  {
    section: WIKI_LISTING_SECTION.harryPotterWiki,
    label: 'ГАРРИ ПОТТЕР ВИКИ',
    href: '/wiki/harry-potter-wiki',
  },
] as const;

export function getWikiListingTypes(section: WikiListingSection): string | readonly string[] {
  switch (section) {
    case WIKI_LISTING_SECTION.faq:
      return WIKI_FAQ_LIST_TYPES;
    case WIKI_LISTING_SECTION.harryPotterWiki:
      return WIKI_ARTICLE_TYPE.harryPotterWiki;
    default:
      return WIKI_ALL_LIST_TYPES;
  }
}
